import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import ProcessAssigneeElement from '../../../processes/process_assignee/ProcessAssigneeElement';
import {useTaskView} from '../context/task_view.context';
import TaskViewTimer from './TaskViewTimer';
import {getAssignees} from './getAssignees';

const TaskViewHeader: FC = () => {
  const {t} = useTranslation('tasks');
  const {
    process,
    currentTasks,
    processAlertData,
    setProcessActionsPopupData,
    availableProcessAssigneeGroups
  } = useTaskView();

  const {
    id: processId = 0,
    treatment,
    patient,
    callSheet,
    startedAt,
    targetTime,
    completedAt,
    assignees: processAssignees = []
  } = process || {};

  const taskAssignees = getAssignees(currentTasks);

  return (
    <div className="tasks-header container">
      <div className="tasks-header_wrapper">
        <div className="tasks-header_element">
          <p className="tasks-header_element-title">{t('diagram.header.treatment')}</p>
          <p className="tasks-header_element-data">
            {treatment && treatment.displayName}
          </p>
        </div>
        <div className="tasks-header_element">
          <ProcessAssigneeElement
            assignees={processAssignees}
            processId={processId}
            processData={process}
            setProcessActionsPopupData={setProcessActionsPopupData}
            availableProcessAssigneeGroups={availableProcessAssigneeGroups}
          />
        </div>
        <div className="tasks-header_element">
          <p className="tasks-header_element-title">{t('diagram.header.patient')}</p>
          <p className="tasks-header_element-data">
            {patient && `${patient.firstName} ${patient.lastName}`}
          </p>
        </div>
        <div className="tasks-header_element">
          <p className="tasks-header_element-title">{t('diagram.header.operatory')}</p>
          <p className="tasks-header_element-data">
            {callSheet?.appointment?.operatory &&
            callSheet.appointment.operatory.number}
          </p>
        </div>
        <div className="tasks-header_element">
          <p className="tasks-header_element-title">{t('diagram.header.teamMember')}</p>
          {taskAssignees.map((assigneeName, index) => (
            <p key={`${assigneeName}-${index}`} className="tasks-header_element-data">{assigneeName}</p>
          ))}
        </div>
        <TaskViewTimer
          startedAt={startedAt}
          targetTime={targetTime}
          completedAt={completedAt}
          processAlertData={processAlertData}
        />
      </div>
    </div>
  );
};

export default TaskViewHeader;
